import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import emptycartimage from "../assets/images/emptycart1.svg";
import {
  fetchCart,
  removeFromCart,
  updateCartItem,
  clearCartAsync,
  fetchTaxRate,
} from "../slices/cartSlice";
import Button from "../components/utilComponents/Button";
import Loader from "../components/utilComponents/Loader";
import CartInput from "../components/utilComponents/CartInput";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cartItems, totalPrice, isLoading, taxRate } = useSelector(
    (state) => state.cart,
  );
  const [isUpdating, setIsUpdating] = useState(false);
  const [canShowEmptyCart, setCanShowEmptyCart] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCanShowEmptyCart(true);
    }, 2500); // delay by 500ms, adjust as needed

    return () => clearTimeout(timer); // cleanup
  }, []);

  useEffect(() => {
    dispatch(fetchCart());
    dispatch(fetchTaxRate());
  }, [dispatch]);

  const handleRemoveItem = async (productId) => {
    setIsUpdating(true);
    await dispatch(removeFromCart(productId));
    setIsUpdating(false);
  };

  const handleQuantityChange = async (productId, newQuantity) => {
    if (newQuantity > 0) {
      setIsUpdating(true);
      await dispatch(updateCartItem({ productId, qty: newQuantity }));
      setIsUpdating(false);
    }
  };

  const taxAmount = (totalPrice * (taxRate / 100)).toFixed(2);
  const grandTotal = (parseFloat(totalPrice) + parseFloat(taxAmount)).toFixed(
    2,
  );

  const formattedTaxAmount = Number(taxAmount).toLocaleString("en-NG");
  const formattedGrandTotal = Number(grandTotal).toLocaleString("en-NG");

  const handleClearCart = async () => {
    setIsUpdating(true);
    await dispatch(clearCartAsync());
    await dispatch(fetchCart());
    setIsUpdating(false);
  };

  if (isLoading || isUpdating) {
    return (
      <div>
        <div className=" md:hidden mx-2">
          <Loader count={1} columns={1} itemClass="h-[320px]" />
          <Loader count={1} columns={1} itemClass="h-[200px]" />
        </div>
        <div className="hidden md:block container">
          <Loader count={2} columns={2} itemClass="h-[320px]" />
        </div>
      </div>
    );
  }

  // if (!cartItems?.length) {
  //   return (
  //     // <div className="order-summary mt-2 md:mt-0 mx-2 md:mx-auto h-[50vh] md:container p-8 empty-cart">
  //     <div className="order-summary mt-2 md:mt-0 mx-2 md:mx-auto h-[60vh] md:container p-8 empty-cart">
  //       <h2 className="font-nunito text-agBlack font-semibold text-lg">
  //         Shopping Cart
  //       </h2>
  //       <div className="">
  //         <div className="mx-auto flex flex-col space-y-4 items-center h-full">
  //           <div className="">
  //             <img
  //               src={emptycartimage}
  //               alt="Empty Cart"
  //               className="w-200 lg:w-256"
  //             />
  //           </div>
  //           <h3 className="pt-8">Hey! It looks empty!</h3>
  //           <p className="text-sm text-agLightGray">
  //             Let’s add some items to make it heavy.
  //           </p>
  //           <Button onClick={() => navigate("/")}>SHOP NOW</Button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  if (canShowEmptyCart && !cartItems?.length) {
    return (
      // <div className="order-summary mt-2 md:mt-0 mx-2 md:mx-auto h-[50vh] md:container p-8 empty-cart">
      <div className="order-summary mt-2 md:mt-0 mx-2 md:mx-auto h-[60vh] md:container p-8 empty-cart">
        <h2 className="font-nunito text-agBlack font-semibold text-lg">
          Shopping Cart
        </h2>
        <div className="">
          <div className="mx-auto flex flex-col space-y-4 items-center h-full">
            <div className="">
              <img
                src={emptycartimage}
                alt="Empty Cart"
                className="w-200 lg:w-256"
              />
            </div>
            <h3 className="pt-8">Hey! It looks empty!</h3>
            <p className="text-sm text-agLightGray">
              Let’s add some items to make it heavy.
            </p>
            <Button onClick={() => navigate("/shop")}>SHOP NOW</Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Desktop View */}
      <div className="hidden lg:flex m-2 md:container flex flex-col space-y-4 md:flex-row md:space-x-8 md:space-y-0">
        {/* Cart Items Section */}
        <div className="flex-4 order-summary">
          <div className="flex justify-between mx-4 items-center">
            <p className="font-nunito text-agBlack font-semibold text-lg">
              Shopping Cart
            </p>
            <p
              className="text-agRedBg hover:text-agRed cursor-pointer"
              onClick={handleClearCart}
            >
              Clear Cart
            </p>
          </div>
          <div className="rounded-xl p-4 mt-4">
            {cartItems.map((item) => (
              <div
                key={item.product._id}
                className="flex space-x-2 items-center border-b  p-2 my-4"
              >
                {/* Product Image */}
                <div className="flex-1">
                  <img
                    className="w-24"
                    src={
                      item.product.images?.[0] ||
                      "/path/to/placeholder-image.jpg"
                    }
                    alt={item.product?.title || "Untitled Product"}
                    style={{
                      maxWidth: "100px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                {/* Product Details */}
                <div className="flex-3">
                  <h4
                    onClick={() => navigate(`/products/${item.product._id}`)}
                    className="text-agLightGray text-sm font-nunito w-56 cursor-pointer hover:text-agBlack transition"
                  >
                    {item.product?.title || "Untitled Product"}
                  </h4>

                  <p className="text-agLightGray text-xs">
                    <span>by</span>{" "}
                    <span
                      className="cursor-pointer text-agBlue"
                      onClick={() => navigate(`/vendors/${item.storeName}`)}
                    >
                      {item.storeName || "Unknown Store"}
                    </span>
                  </p>
                </div>
                {/* Quantity Controls */}
                <div className="flex-1">
                  <div className="flex items-center space-x-2">
                    <span
                      className="material-symbols-rounded text-agPrimary cursor-pointer"
                      onClick={() =>
                        handleQuantityChange(item.product._id, item.qty - 1)
                      }
                    >
                      remove
                    </span>
                    <CartInput
                      type="number"
                      value={item.qty}
                      onChange={(e) =>
                        handleQuantityChange(
                          item.product._id,
                          parseInt(e.target.value, 10),
                        )
                      }
                      className="text-center w-8 text-agBlack"
                    />
                    <span
                      className="material-symbols-rounded text-agPrimary cursor-pointer"
                      onClick={() =>
                        handleQuantityChange(item.product._id, item.qty + 1)
                      }
                    >
                      add
                    </span>
                  </div>
                </div>
                {/* Price Details */}
                <div className="flex-1">
                  <div className="flex flex-col space-y-2 items-center">
                    <p className="text-agBlack font-regular text-lg">
                      ₦
                      {(item.price * item.qty).toLocaleString("en-NG", {
                        minimumFractionDigits: 2,
                      })}
                    </p>
                    <p className="text-agLightGray text-sm">
                      {item.qty} x ₦
                      {item.price.toLocaleString("en-NG", {
                        minimumFractionDigits: 2,
                      })}
                    </p>
                    <button
                      className="text-agRedBg hover:text-agRed cursor-pointer flex items-center space-x-1"
                      onClick={() => handleRemoveItem(item.product._id)}
                    >
                      <span className="material-icons-round text-sm">
                        delete
                      </span>
                      <span className="text-sm">Remove</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Order Summary Section */}
        <div className="flex-2 w-full lg:w-[30vw]">
          <div className="order-summary">
            <h3 className="font-nunito text-agBlack font-semibold text-lg">
              Order Summary
            </h3>
            <hr className="mb-4" />
            <div className="order-summary-details">
              <div className="order-summary-item">
                <span className="text-sm text-agLightGray">Subtotal</span>
                <span className="text-sm text-agBlack ">
                  ₦{totalPrice.toLocaleString("en-NG")}
                </span>
              </div>
              <div className="order-summary-item">
                <span className="text-sm text-agLightGray">Shipping</span>
                <span className="text-sm text-agBlack ">₦0.00</span>
              </div>
              <div className="order-summary-item">
                <span className="text-sm text-agLightGray">
                  Tax ({taxRate}%)
                </span>
                <span className="text-sm text-agBlack ">
                  ₦{formattedTaxAmount}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Total</span>
                <span className="text-agBlack font-nunito font-bold text-lg">
                  ₦{formattedGrandTotal}
                </span>
              </div>
            </div>
            {/* <Button variant="primary" fullWidth>
              CONTINUE
            </Button> */}
            <Button
              variant="primary"
              fullWidth
              onClick={() => navigate("/checkout/shipping")}
            >
              CONTINUE
            </Button>
          </div>
        </div>
      </div>
      {/* Mobile View */}
      <div className="lg:hidden m-2 flex flex-col space-y-4 ">
        {/* Cart Items Section */}
        <div className="flex-4 order-summary">
          <div className="flex justify-between  items-center">
            <p className="font-nunito text-agBlack font-semibold text-lg">
              Shopping Cart
            </p>
            <p
              className="text-sm text-agRedBg hover:text-agRed cursor-pointer"
              onClick={handleClearCart}
            >
              Clear Cart
            </p>
          </div>

          <div className="rounded-xl mt-0">
            {cartItems.map((item) => (
              <div
                key={item.product._id}
                className="flex space-x-2 border-b pb-4 my-4 items-center"
              >
                {/* Image Container */}
                <div className="flex-1">
                  <img
                    className="w-24"
                    src={
                      item.product.images?.[0] ||
                      "/path/to/placeholder-image.jpg"
                    }
                    alt={item.product?.title || "Untitled Product"}
                    style={{
                      maxWidth: "100px",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* Product Information */}
                <div className="flex-3">
                  <div className="text-sm font-nunito text-agBlack w-[60vw]">
                    {item.product?.title || "Untitled Product"}
                  </div>
                  <div className="text-xs text-agLightGray">
                    <span>by </span>
                    <span className="text-agBlue cursor-pointer">
                      {item.storeName || "Unknown Store"}
                    </span>
                  </div>

                  {/* Product Details and Controls */}
                  <div className="flex space-x-2 items-center mt-2">
                    {/* Price and Breakdown */}
                    <div className="flex-1">
                      <div className="text-sm font-bold text-agBlack">
                        ₦
                        {(item.price * item.qty).toLocaleString("en-NG", {
                          minimumFractionDigits: 2,
                        })}
                      </div>
                      <div className="text-xs text-agLightGray">
                        {item.qty} x ₦
                        {item.price.toLocaleString("en-NG", {
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </div>

                    {/* Quantity Controls */}
                    <div className="flex space-x-0 items-center">
                      <span
                        className="material-symbols-rounded text-agPrimary cursor-pointer"
                        onClick={() =>
                          handleQuantityChange(item.product._id, item.qty - 1)
                        }
                      >
                        remove
                      </span>
                      <CartInput
                        type="number"
                        value={item.qty}
                        onChange={(e) =>
                          handleQuantityChange(
                            item.product._id,
                            parseInt(e.target.value, 10),
                          )
                        }
                        className="text-center w-8 text-agBlack"
                      />
                      <span
                        className="material-symbols-rounded text-agPrimary cursor-pointer pr-2"
                        onClick={() =>
                          handleQuantityChange(item.product._id, item.qty + 1)
                        }
                      >
                        add
                      </span>
                    </div>

                    {/* Remove Button */}
                    {/* <div>
                      <button
                        className="text-xs text-agRedBg hover:text-agRed cursor-pointer flex items-center"
                        onClick={() => handleRemoveItem(item.product._id)}
                      >
                        <span className="material-icons-round text-sm">
                          delete
                        </span>
                        <span className="text-sm">Remove</span>
                      </button>
                    </div> */}
                  </div>
                  <div>
                    <button
                      className="text-xs text-agRedBg hover:text-agRed cursor-pointer flex items-center"
                      onClick={() => handleRemoveItem(item.product._id)}
                    >
                      <span className="material-icons-round text-sm">
                        delete
                      </span>
                      <span className="text-sm">Remove</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Order Summary Section */}
        <div className="flex-2 w-full lg:w-[30vw]">
          <div className="order-summary">
            <h3 className="font-nunito text-agBlack font-semibold text-lg">
              Order Summary
            </h3>
            <hr className="mb-4" />
            <div className="order-summary-details">
              <div className="order-summary-item">
                <span className="text-sm text-agLightGray">Subtotal</span>
                <span className="text-sm text-agBlack ">
                  ₦{totalPrice.toLocaleString("en-NG")}
                </span>
              </div>
              <div className="order-summary-item">
                <span className="text-sm text-agLightGray">Shipping</span>
                <span className="text-sm text-agBlack ">₦0.00</span>
              </div>
              <div className="order-summary-item">
                <span className="text-sm text-agLightGray">
                  Tax ({taxRate}%)
                </span>
                <span className="text-sm text-agBlack ">
                  ₦{formattedTaxAmount}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Total</span>
                <span className="text-agBlack font-nunito font-bold text-lg">
                  ₦{formattedGrandTotal}
                </span>
              </div>
            </div>
            {/* <Button variant="primary" fullWidth>
              CONTINUE
            </Button> */}
            <Button
              variant="primary"
              fullWidth
              onClick={() => navigate("/checkout/shipping")}
            >
              CONTINUE
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cart;
